import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { setActiveTab } from '../../actions/profileForm';
import { translate } from 'react-i18next';

import Button from '../layout/Button';
import Panel from '../layout/Panel';
import BrightnessTabs from './BrightnessTabs';
import BrightnessGraph from './BrightnessGraph';

import { Icon } from '../icons';
import styles from './show.scss';

class Show extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      t,
      profile,
      devices,
      history,
      location,
      match,
      activeTab,
      setActiveTab
    } = this.props;

    if(!profile)
      return null;

    return(
      <Panel
        onCloseClick={() => history.push(`/organisations/${match.params.organisationId}/profiles${location.search}`)}
        title={`Profile: ${profile.name}`}>
        <div className="device-selection">
          <div className="profile-chart">
            <BrightnessTabs activeTab={activeTab} brightness={profile.brightness} onChange={setActiveTab} />
            <div className="chart-container">
              {profile.brightness[activeTab] ? (
                <div>
                  <div className="profile-edit-container profile-edit-container-hover">
                    <Link className="profile-edit" to={`/organisations/${match.params.organisationId}/profiles/${profile.id}/edit${location.search}`}><Icon className="profile-edit-icon" type={'pencil'} /></Link>
                  </div>
                  <BrightnessGraph brightness={profile.brightness[activeTab]} />
                </div>
              ) :
                <div style={{padding: 10, textAlign: 'center'}}>
                  <p>{t('NOT_CONFIGURED_DAY_PROFILE')}</p>
                  <div className="profile-edit-container">
                    <Link className="profile-edit" to={`/organisations/${match.params.organisationId}/profiles/${profile.id}/edit${location.search}`}><Icon className="profile-edit-icon" type={'pencil'} /></Link>
                  </div>
                </div>
              }

            </div>
          </div>
          <div className="text-break">
            <p>{t('PROFILE_USED_BY')}:</p>
          </div>
          <div className="devices-list">
            <Link className="btn add-devices-btn" to={`/organisations/${match.params.organisationId}/profiles/${profile.id}/devices${location.search}`}>+</Link>
            <ul>
              {devices.slice(0, 40).map(device =>
                <li key={device.id}>
                  <div className="device-icon">
                    <Icon type={'circle'} />
                  </div>
                  <div className="device-name">
                    {device.name}
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Panel>
    )
  }
}

export default translate('profile')(withRouter(connect(
  ({ profiles, devices, ui }, { match} ) => {
    const profileId = match.params.profileId;
    return {
      profile: profiles.data.find(profile => profile.id === profileId),
      devices: devices.data.filter(device => device.profile_id === profileId),
      activeTab: ui.profileForm.activeTab // probably should have it's own state
    }
  },
  dispatch => ({
    setActiveTab: (tab) => dispatch(setActiveTab(tab)) // probably should have it's own action
  })
)(Show)));



// WEBPACK FOOTER //
// ./src/components/profiles/Show.js